import React from 'react';

const styles = {
  root: {
    margin: 0,
    padding: 0,
    display: 'flex',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    background: 'transparent',
    justifyContent: 'center',
    alignItems: 'stretch',
    position: 'relative',
    pointerEvents: 'none',
    zIndex: 1,
    opacity: 0.9,
    transition: 'opacity 0.3s ease-in-out',
  },
  svgOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 1,
    color: 'white',
    fontSize: '2rem',
    width: '390px',
  },
  cover: {
    flex: 1,
    backgroundColor: 'black',
  },
};

const SvgBlackCover = ({ isOpen }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <div style={{ ...styles.root }}>
      <div style={styles.cover} />
      <div style={styles.content} />
      <div style={styles.cover} />
    </div>
  );
};

export default SvgBlackCover;
